import { OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

export abstract class BaseModalComponent implements OnInit {

  public confirmResult: Subject<boolean> = new Subject<boolean>();

  public bsModalRef: BsModalRef;

  public title: string = '';
  public subtitle: string = '';
  public message: string = '';
  public showCancelButton: boolean = true;
  public confirmText: string = 'Si';
  public cancelText: string = 'No';
  public size: 'sm' | 'lg' | 'xl' = 'lg';

  constructor() {}

  ngOnInit(): void {
    this.onInit();
  }

  /**
   * Hook for subclasses to add custom initialization
   */
  protected onInit(): void {
    // Override in subclasses if needed
  }

  /**
   * Confirms the modal action and closes it
   */
  confirm(): void {
    this.confirmResult.next(true);
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  /**
   * Declines the modal action and closes it
   */
  decline(): void {
    this.confirmResult.next(false);
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  /**
   * Sets the modal reference (called by the modal service)
   */
  setModalRef(bsModalRef: BsModalRef): void {
    this.bsModalRef = bsModalRef;
  }

  /**
   * Handles overlay click events.
   * Does nothing by default - overlay click does not close modal.
   * Override in subclasses if different behavior is needed.
   */
  onOverlayClick(event: Event): void {
    // Do nothing - overlay click doesn't close modal
  }
}
